import { isLoadingReducer } from 'store/reducerUtils';
import { setActivityStatus } from 'modules/settings/submodules/clients/activities/components/ClientActivitiesTable/components/UpdateStatusSelect/store/actions';

export const isActivityStatusUpdating = isLoadingReducer(setActivityStatus);
